import { MenuType } from '../enums/menu-type';
import { PermissionCode } from '../enums/permission-code';

export class Menu {
  route!: string;
  queryParams?: Record<string, string>;
  name!: string;
  iconURL!: string;
  type!: MenuType;
  permission!: string;
  conditions?: MenuCondition[];
  conditionMatchType?: ConditionMatchType;
  sub: Menu[] = [];
  isExpanded?: boolean;
  smeOnly?: boolean;
}

export enum ConditionMatchType {
  All = 'all',
  Any = 'any',
}

export interface MenuCondition {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  check: (context: Record<string, any>) => boolean;
}

export const MenuList: Menu[] = [
  {
    route: 'dashboard',
    iconURL: 'dashboard.svg',
    name: 'Dashboard',
    type: MenuType.Main,
    permission: 'common',
    sub: [],
  },
  {
    route: 'leads',
    iconURL: 'leads.svg',
    name: 'Leads',
    type: MenuType.Main,
    permission:
      PermissionCode.GET_SET_LEADS +
      '|' +
      PermissionCode.CUSTOM_BUSINESS_RECORD +
      '|' +
      PermissionCode.ACCESS_DATA_AXLE +
      '|' +
      PermissionCode.ACCESS_CRF +
      '|' +
      PermissionCode.ACCESS_DEEPROOTS,
    sub: [
      {
        route: 'my-leads',
        iconURL: 'restricted-users.svg',
        name: 'My Leads',
        type: MenuType.Sub,
        permission: PermissionCode.GET_SET_LEADS,
        sub: [],
      },
      {
        route: 'find',
        iconURL: 'search.svg',
        name: 'Find Leads',
        type: MenuType.Sub,
        permission:
          PermissionCode.CUSTOM_BUSINESS_RECORD +
          '|' +
          PermissionCode.ACCESS_DATA_AXLE +
          '|' +
          PermissionCode.ACCESS_CRF +
          '|' +
          PermissionCode.ACCESS_DEEPROOTS,
        sub: [],
      },
      {
        route: 'ai-search',
        iconURL: 'ai-search.svg',
        name: 'AI Search Lab',
        type: MenuType.Sub,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
    ],
  },
  {
    route: 'files',
    iconURL: 'files.svg',
    name: 'Files',
    type: MenuType.Main,
    permission: PermissionCode.UPLOAD_RECORDS,
    conditions: [
      {
        check: (context) => !context['authService'].isSMEUser(),
      },
    ],
    conditionMatchType: ConditionMatchType.All,
    sub: [],
  },
  {
    route: 'deeproots',
    iconURL: 'deeproots.svg',
    name: 'DeepRoots',
    type: MenuType.Main,
    permission:
      PermissionCode.MANAGE_PUBLIC_LINKS +
      '|' +
      PermissionCode.MANAGE_MATCHING_CRITERIA,
    sub: [
      {
        route: 'links',
        iconURL: 'link.svg',
        name: 'Links',
        type: MenuType.Sub,
        permission: PermissionCode.MANAGE_PUBLIC_LINKS,
        sub: [],
      },
      {
        route: 'leads-criteria',
        iconURL: 'matching-criteria.svg',
        name: 'Lead Criteria',
        type: MenuType.Sub,
        permission: PermissionCode.MANAGE_MATCHING_CRITERIA,
        sub: [],
      },
    ],
  },
  {
    route: 'cdfis',
    iconURL: 'cdfis-list.svg',
    name: 'Organizations',
    type: MenuType.Main,
    permission: 'common',
    // conditions: [
    //   {
    //     check: (context) => context['authService'].isSMEUser(),
    //   },
    // ],
    // conditionMatchType: ConditionMatchType.All,
    sub: [],
  },
  {
    route: 'achievements',
    iconURL: 'achievement.svg',
    name: 'Achievements',
    type: MenuType.Main,
    permission: 'common',
    conditions: [
      {
        check: (context) => !context['authService'].isSMEUser(),
      },
    ],
    conditionMatchType: ConditionMatchType.All,
    sub: [],
  },
  {
    route: 'business',
    iconURL: 'records.svg',
    name: 'Business Needs',
    type: MenuType.Main,
    permission: 'common',
    smeOnly: true,
    sub: [],
  },
  {
    route: 'matches',
    iconURL: 'matched-records.svg',
    name: 'Matches',
    type: MenuType.Main,
    permission: 'common',
    smeOnly: true,
    sub: [],
  },
  {
    route: 'flags',
    iconURL: 'flags.svg',
    name: 'My Flags',
    type: MenuType.Main,
    permission: 'common',
    sub: [],
  },
  {
    route: 'announcements',
    iconURL: 'announcement.svg',
    name: 'Announcements',
    type: MenuType.Admin,
    permission: PermissionCode.ADMIN_PRIVILEGES,
    sub: [],
  },
  {
    route: 'connection-signup-requests',
    iconURL: 'signup-requests.svg',
    name: 'Signup Requests',
    type: MenuType.Admin,
    permission: PermissionCode.ADMIN_PRIVILEGES,
    sub: [],
  },
  {
    route: '',
    iconURL: 'manage.svg',
    name: 'Manage',
    type: MenuType.Admin,
    permission: PermissionCode.ADMIN_PRIVILEGES,
    sub: [
      {
        route: 'manage-connection-group',
        iconURL: 'manage-connections.svg',
        name: 'Connections',
        type: MenuType.Admin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'manage-users',
        iconURL: 'manage-users.svg',
        name: 'Users',
        type: MenuType.Admin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'manage-duplicates',
        iconURL: 'duplicate-business.svg',
        name: 'Duplicate Businesses',
        type: MenuType.Admin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'dnd-list',
        iconURL: 'dnd.svg',
        name: 'DND List',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'manage-flags',
        iconURL: 'flags.svg',
        name: 'Flags',
        type: MenuType.Admin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
    ],
  },
  {
    route: 'configs',
    iconURL: 'config.svg',
    name: 'Configurations',
    type: MenuType.Admin,
    permission: PermissionCode.ADMIN_PRIVILEGES,
    sub: [
      {
        route: 'manage-subscription-plans',
        iconURL: 'manage-subscription-plans.svg',
        name: 'Subscription Plans',
        type: MenuType.Admin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'cdfi-leads-quota',
        iconURL: 'cdfi-leads-quota-logs.svg',
        name: 'CDFI Leads Quota',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
    ],
  },
  {
    route: 'logs',
    iconURL: 'logs.svg',
    name: 'Logs',
    type: MenuType.Admin,
    permission: PermissionCode.ADMIN_PRIVILEGES,
    sub: [
      {
        route: 'cdfi-outreach',
        iconURL: 'cdfi-outreach-logs.svg',
        name: 'WNCSBI Outreach',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'deeproots',
        iconURL: 'deeproots.svg',
        name: 'Deeproots',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'lead-status',
        iconURL: 'lead-status.svg',
        name: 'Lead Status',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      // {
      //   route: 'vlf-lifecycle',
      //   iconURL: 'vlf-logs.svg',
      //   name: 'VLF',
      //   type: MenuType.SubAdmin,
      //   permission: PermissionCode.ADMIN_PRIVILEGES,
      //   sub: [],
      // },
      {
        route: 'email-log',
        iconURL: 'emails.svg',
        name: 'Emails',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
      {
        route: 'audit-logs',
        iconURL: 'records.svg',
        name: 'Audit',
        type: MenuType.SubAdmin,
        permission: PermissionCode.ADMIN_PRIVILEGES,
        sub: [],
      },
    ],
  },
];

export const NonMenuList: Menu[] = [
  {
    route: 'profile',
    iconURL: 'user-solid.svg',
    name: 'Profile',
    type: MenuType.None,
    permission: 'common',
    sub: [],
  },
  {
    route: 'profile/:id',
    iconURL: 'user-solid.svg',
    name: 'Profile',
    type: MenuType.None,
    permission: 'common',
    sub: [],
  },
  {
    route: 'change-password',
    iconURL: 'change-password.svg',
    name: 'Change Password',
    type: MenuType.None,
    permission: 'common',
    sub: [],
  },
  {
    route: 'notifications',
    iconURL: 'bell.svg',
    name: 'Notifications',
    type: MenuType.None,
    permission: 'common',
    sub: [],
  },
  {
    route: 'subscription',
    iconURL: 'bell.svg',
    name: 'Subscription',
    type: MenuType.None,
    permission: 'common',
    sub: [],
  },
];
export { MenuType };
